import {
  SET_PAGE_TITLE,
  SET_PAGE_SUBTITLE,
  SET_PAGE_ICON,
  SET_PAGE_TYPE,
} from '../actions/pageInfo';

const initialState = {
  pageTitle: '',
  pageSubtitle: '',
  pageIcon: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_PAGE_TITLE: {
      return {
        ...state,
        pageTitle: action.payload,
      };
    }

    case SET_PAGE_SUBTITLE: {
      return {
        ...state,
        pageSubtitle: action.payload,
      };
    }

    case SET_PAGE_ICON: {
      return {
        ...state,
        pageIcon: action.payload,
      };
    }

    case SET_PAGE_TYPE: {
      return {
        ...state,
        pageType: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};
